import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';
import { helveticaBold, typographStyles } from '../../theme-constants/typograhy-overrides';



export const coverageTableStyles = makeStyles((theme) => ({
    coverageTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(1.5),
        },
        borderRadius: '3px',
        '& .MuiFormGroup-root': {
            '& > .coverage-table-row': {
                '&:nth-child(even)': {
                    backgroundColor: tcsmColors.greySeven,
                },
                '&-blue': {
                    background: '#EAECF3 !important',
                },
            },
        },
        '& .coverage-table': {
            '&-row': {
                margin: 0,
                padding: 0,
                [theme.breakpoints.up('sm')]: {
                    display: 'table',
                    tableLayout: 'fixed',
                    width: '100%',
                    maxWidth: '100%',
                },
                [theme.breakpoints.down('xs')]: {
                    padding: theme.spacing(1),
                },
                '&-cell': {
                    [theme.breakpoints.up('sm')]: {
                        display: 'table-cell',
                        overflowWrap: 'break-word',
                        padding: theme.spacing(1),
                    },
                   
                    '&:first-child': {
                        [theme.breakpoints.up('sm')]: {
                            width: '40%',
                        },
                    },

                    '&-tooltip': {
                        '& > *': {
                            display: 'inline-block',
                        },
                        '&-inner': {
                            marginLeft: theme.spacing(.5),
                        },
                    },
                },
                '&.header-row': {
                    background: tcsmColors.blue,
                    color: tcsmColors.white,

                    '&-bottom-align': {
                        '& .coverage-table-row-cell': {
                            verticalAlign: 'bottom',
                        },
                        
                    },
                },
                
            },
            '&-radio': {
                '&-container': {
                    '& > .MuiFormControlLabel': {
                        '&-root': {
                            '& > * ': {
                                color: tcsmColors.black,
                            },
                            '& .MuiFormControlLabel-label': typographStyles.inputLabel,
                        },

                    },
                    [theme.breakpoints.up('md')]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        
                    },
                    '& > .MuiGrid-container': {
                        width: 'auto',
                        [theme.breakpoints.up('md')]: {
                            width: '60%',
                        },

                        
                    },
                    '&-hide': { // overrides to hide radio 

                        '& .MuiButtonBase-root.Mui-disabled': {
                            display: 'none',
                        },
                        '& .MuiFormControlLabel-root.Mui-disabled': {
                            marginLeft: '0',
                        },
                    },

                },
                '&-supplement': {
                    flex: '0 1 auto',
                    
                    [theme.breakpoints.up('md')]: {
                        width: '40%',
                        marginBottom: '0',
                    },
                    '& > a': {
                        display: 'flex',


                        '& > svg': {
                            width: '1.25rem',
                            height: '1.25rem',
                            marginRight: theme.spacing(.25),
                        },
                    },
                    '&-form': {
                        [theme.breakpoints.down('md')]: {
                            marginTop: theme.spacing(1),
                        },
                    },
                },
            },
        },
        '& .tier-cell': {
            textAlign: 'right',
            position: 'relative',

            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                marginBottom: theme.spacing(1),
                textAlign: 'left',

            },
            '&-inner': {
                display: 'flex',
                width: '75%',
                alignItems: 'center',
                justifyContent: 'space-between',

                [theme.breakpoints.up('sm')]: {
                    justifyContent: 'center',
                    display: 'inline-flex',
                    width: 'auto',
                    alignItems: 'stretch',

                },
            },
            '&-item': {
                [theme.breakpoints.down('xs')]: {
                    /* width: '50%',*/
                },

                '&-expired': {
                    color: tcsmColors.red,
                },
            },
            '&-name': {
                marginLeft: theme.spacing(2),
                [theme.breakpoints.down('xs')]: {
                    flex: '50%',
                },
            },
            '&-indicator': {
                position: 'absolute',
                top: '0',
                width: '1.5rem',
                height: '1.5rem',
                fill: tcsmColors.green,
                [theme.breakpoints.down('xs')]: {
                    transform: 'rotate(-90deg)',
                    top: 'auto',
                },
            },
            '&-highlight': {
                '& .tier-cell-value': {
                    color: tcsmColors.green,
                    fontFamily: helveticaBold,
                },
            },
        },
    },
    coverTableHeader: {
        '& .coverage-table-header': {
            '&-title': {
                marginBottom: theme.spacing(1),
            },

            '&-tooltip': {
                display: 'flex',


             
                    marginTop: theme.spacing(1),
                '&-text': {
                    marginRight: theme.spacing(.5),
                },
            },
        },
    },


}));

